import {
  TransactionEstimateParams,
  TransactionEstimatesResponse,
} from 'models/TransactionEstimates'
import toAPIv2QueryString from 'utils/functions/toAPIv2QueryString'
import { api } from '../api'

export const feesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getFeeEstimate: builder.query<
      TransactionEstimatesResponse,
      { campaignId: string; params: TransactionEstimateParams }
    >({
      query: ({ campaignId, params }) =>
        `/campaigns/${campaignId}/transaction-estimates?${toAPIv2QueryString(params)}`,
    }),
  }),
})

/**
 * Export the query hooks as well as the endpoints (for SSR).
 */
export const {
  endpoints: { getFeeEstimate },
  useGetFeeEstimateQuery,
} = feesApi
